import React, { useState } from 'react'

import { useStyles } from './table-section.style'
import { TableRowMemo } from './table-row'

const TableSection = function ({ section, columns, selectedRows = new Set(), shiftBy, onClick }) {
  const classes = useStyles()
  const [isCollapsed, setIsCollapsed] = useState(section.isCollapsed)

  return (
    <>
      <div
        className={classes.sectionLabelCell}
        onClick={() => { setIsCollapsed(!isCollapsed) }}
        data-qa={'section-head-' + section.key}>

        {/* TODO: replace with icon font set */}
        <div className={classes.sectionToggle}>
          <img className={classes.sectionToggleIcon} src={isCollapsed
            ? '//cdnjs.cloudflare.com/ajax/libs/open-iconic/1.1.1/svg/chevron-right.svg'
            : '//cdnjs.cloudflare.com/ajax/libs/open-iconic/1.1.1/svg/chevron-bottom.svg'}>
          </img>
        </div>
        {section.label}
      </div>
      <div
        className={`${classes.dataRowsBody} ${isCollapsed ? classes.collapsed : ''}`}
        data-qa={'section-body-' + section.key}
      >
        {section.rows.map((row, index) => (
          <TableRowMemo rows={section.rows} index={index} key={row.key} selectedRows={selectedRows} columns={columns} section={section} shiftBy={shiftBy} onClick={onClick} />
        ))}
      </div>
    </>
  )
}

export {
  TableSection
}
